'use client'

import AppError from '@/app/error'
import { addToast } from '@heroui/react'
import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    addToast({
      title: error.message || 'Something went wrong',
      color: 'danger',
    })
  }, [error])

  return <AppError error={error} reset={reset} />
}
